import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PartnerTeamService {
  private baseUrl = `${environment.urlConfig.serviceUrl}/partnerteams`;

  constructor(private http: HttpClient) { }

  get(partnerId: number): Observable<Boo.Objects.PartnerTeam> {
    const params = new HttpParams().set('partnerId', partnerId);

    return this.http.get<Boo.Objects.PartnerTeam>(this.baseUrl, { params: params });
  }
}
